import { Items } from 'src/app/core/models/common/items.model';
import { IOption } from '../../form/components/form-select/form-select.model';

export enum ColumnIds {
  ULD_NUMBER = 'uldNumber',
  ULD_TYPE = 'uldType',
  SEAL_NUMBER = 'sealNumber',
  LOAD_KEY = 'loadKey',
  LOAD_CHART = 'loadChart',
  MOVEMENT = 'movement',
  ULD_COUNT = 'uldCount',
  ULD_PKG_COUNT = 'pkgCount',
  LOAD_CREATE_DATE = 'loadCreateDate',
  ORIGIN_SORT = 'origSort',
}

export const CONST = {
  SELECT_DATE: $localize`Select Date`,
  HEADER: $localize`Active Carry Over Loads`,
  CLOSE_DATE: $localize`Close Date`,
  CLOSE_TIME: $localize`Close Time`,
  PERCENT_FULL: $localize`Percent Full`,
  SUBMIT: $localize`Submit`,
  CLOSE: $localize`Close`,
  LOAD_KEY_UPDATE: $localize`Load Key Update`,
  SEARCH: $localize`Search`,
  SORT_DATE: $localize`Sort Date`,
  SORT_CODE: $localize`Sort Code`,
  BELT: $localize`Belt`,
  BAY: $localize`Bay`,
  SEAL_NUMBER: $localize`Seal Number`,
  EQUIPMENT_NUMBER: $localize`Equipment Number`,
  EQUIPMENT_TYPE: $localize`Equipment Type`,
};

export const ColumnText = {
  ULD_NUMBER: $localize`ULD NUMBER`,
  ULD_TYPE: $localize`ULD Type`,
  SEAL_NUMBER: $localize`Seal Number`,
  LOAD_KEY: $localize`Load Key`,
  LOAD_CHART: $localize`Load Chart`,
  MOVEMENT: $localize`Movement`,
  ULD_COUNT: $localize`ULD Count`,
  PKG_COUNT: $localize`Loose Count`,
  LOAD_CREATE_DATE: $localize`Load Create Date`,
  ORIGIN_SORT: $localize`Origin Sort`,
};

export const SORT_OPTIONS: Items[] = [
  { id: 'S', selected: true },
  { id: 'M', selected: true },
  { id: 'D', selected: true },
  { id: 'T', selected: true },
  { id: 'N', selected: true },
  { id: 'P', selected: true },
  { id: 'L', selected: true },
  { id: 'A', selected: true },
];
export const ULD_TYPE_OPTIONS: Items[] = [
  { id: 'C', label: 'Conditioner - C', selected: true },
  { id: 'T', label: 'Trailer - T', selected: true },
  { id: 'BE', label: 'Belly - BE', selected: true },
  { id: 'PC', label: 'Package Car - PC', selected: true },
  { id: 'CG', label: 'Cage - CG', selected: true },
  { id: 'B', label: 'Bag - B', selected: true },
];
export const SORT_LIST: IOption[] = [
  {
    label: $localize`S`,
    value: 'S',
  },
  {
    label: $localize`M`,
    value: 'M',
  },
  {
    label: $localize`D`,
    value: 'D',
  },
  {
    label: $localize`T`,
    value: 'T',
  },
  {
    label: $localize`N`,
    value: 'N',
  },
  {
    label: $localize`P`,
    value: 'P',
  },
  {
    label: $localize`L`,
    value: 'L',
  },
  {
    label: $localize`A`,
    value: 'A',
  },
];

export const TYPE_OPTIONS: Items[] = [
  { id: 'UP', selected: true },
  { id: 'CO', selected: true },
];

export enum SORTS_TYPES {
  SUNRISE = 'S',
  MORNING = 'M',
  DAY = 'D',
  TWILIGHT = 'T',
  NIGHT = 'N',
  PRELOAD = 'P',
  LOCAL = 'L',
  AFTERNOON = 'A',
}
export enum EQUIPMENT_TYPES {
  CONTAINER = 'Container - C',
  TRAILER = 'Trailer - T',
  BELLY = 'Belly - BE',
  PACKAGE_CAR = 'Package Car - PC',
  CAGE = 'Cage - CG',
  BAG = 'Bag - B',
}
